import TextField from '@mui/material/TextField';
import SimpleDialog from '../../../common/SimpleDialog';
import useChats from '../../hooks/useChats';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

type Props = {
    open: boolean,
    onClose: () => void
}

const ImportUtterancesModal = ({ open, onClose }: Props) => {
    const { addUtterances, generateUtterances } = useChats();
    const [value, setValue] = useState('');
    const [example, setExample] = useState('');
    const [error, setError] = useState(false);
    const [aiError, setAIError] = useState(false);
    const [loading, setLoading] = useState(false)

    const onImport = () => {
        setError(false);

        if (value.trim() === '') {
            setError(true)
        }

        const valueAsArray = value.split(/\r?\n|\r|\n/g).filter(i => i);
        addUtterances(valueAsArray)

        setValue('');

        onClose();
    }

    const handleClose = () => {
        setError(false);
        setValue('');
        onClose();
    }

    const generate = async () => {
        try {
            setAIError(false);
            if (example.trim() === '') {
                setAIError(true);
                return;
            }

            setLoading(true);
            const response = await generateUtterances(example.trim());
            setValue(response);
            setAIError(false);
        } catch (err) {
            setAIError(true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <SimpleDialog open={open} onClose={onClose} sx={{ padding: 5 }} size="md" fullHeight={false}>
            <Box display='flex' flexDirection='column' gap={2} sx={{ hieght: 600, minHeight: 600 }}>
                <Box>
                    <Typography variant='h6'>Import Utterances</Typography>
                    <Box display='flex' gap={2} alignContent='center'>
                        <TextField
                            placeholder='Paste or enter your example sentance here'
                            rows={20}
                            fullWidth
                            sx={{ paddingTop: 2 }}
                            error={aiError}
                            value={example}
                            onChange={(e) => setExample(e.target.value)}
                        />
                        <Button size="small" variant='contained' sx={{ width: 200, alignSelf: 'center' }} disabled={loading} onClick={generate}>{loading ? 'Generating...' : 'AI Generate'}</Button>
                    </Box>
                    <TextField
                        multiline={true}
                        placeholder='Paste or enter your utterances here'
                        rows={20}
                        sx={{ width: '100%', paddingTop: 2 }}
                        error={error}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </Box>
                <Box display='flex' justifyContent='flex-end' gap={2} sx={{ paddingTop: 2 }}>
                    <Button size='small' variant='contained' onClick={handleClose} >Cancel</Button>
                    <Button size='small' variant='contained' onClick={onImport} disabled={loading}>Import</Button>
                </Box>
            </Box>
        </SimpleDialog>
    )
}

export default ImportUtterancesModal;